<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BTable, BOverlay,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import axios from '@axios';
import { required, email } from '@validations';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { ref } from '@vue/composition-api';
import useListClassifisc from '@/views/cadastros-gerais/tipo-pedido-estab/list/useListClassifisc';
import { avatarText } from '@core/utils/filter';
import SLSTipoPedidoEstabClassifiscService from '@/services/SistemaDKP/SLSTipoPedidoEstabClassifisc.service';
import ModalConfirmation from '@/components/ModalConfirmation.vue';

export default {
  components: {
    ModalConfirmation,
    BTable,
    BModal,
    BButton,
    BAlert,
    BOverlay,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopedidoid: '',
        estabelecimentoid: '',
      }),
      require: true,
    },
  },
  data() {
    return {
      dataFromApi: null,
      dataFromClassificacaoFiscal: null,
      deletedClassifisc: null,
      isDeleteModal: false,
      isSaving: false,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.dataTipoPedidoEstabClassifisc;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isFormValid() {
      return (
        this.dataForm.tipopedidoid
        && this.dataForm.estabelecimentoid
        && this.dataForm.classificacaofiscalid
        && this.dataForm.tipopedidoestabnatopestadual
        && this.dataForm.tipopedidoestabnatopinterest
        && this.dataForm.tipopedidoestabnatopestrang
        && this.dataForm.tipopedidoestabnatopncestadual
        && this.dataForm.tipopedidoestabnatopncinterest
        && this.dataForm.tipopedidoestabnatopzf
        && this.dataForm.tipopedidoestabnatopimportado
        && this.dataForm.tipopedidoestabnatopcfestadual
        && this.dataForm.tipopedidoestabnatopcfinterest
        && this.dataForm.tipopedidoestabnatoprvestadual
        && this.dataForm.tipopedidoestabnatoprvinterest
        && this.dataForm.tipopedidoestabnatopareaolivrecom
      );
    },
  },
  methods: {
    async handleSave(data) {
      this.isSaving = true;
      try {
        await this.create(data);
      } finally {
        this.isSaving = false;
        this.formularioVisible(0);
      }
    },
    async handleUpdate(data) {
      this.isSaving = true;
      try {
        await this.Updated(data);
      } finally {
        this.isSaving = false;
        this.formularioVisible(0);
      }
    },
    openModalDeleteClassifisc(data) {
      this.deletedClassifisc = data;
      this.isDeleteModal = true;
    },
    resetFormData() {
      this.deletedClassifisc = null;
      this.isDeleteModal = false;
    },
    handleRemover(data) {
      this.removerData(data);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Classificação deletada com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    async fetchDataFromNaturezaOperacao() {
      try {
        const response = await axios.get('/natureza-operacao');
        this.dataFromApi = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromClassificaçãoFiscal() {
      try {
        const response = await axios.get('/classificacao-fiscal');
        this.dataFromClassificacaoFiscal = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
  created() {
    this.fetchDataFromNaturezaOperacao();
    this.fetchDataFromClassificaçãoFiscal();
  },
  setup(props) {
    const sLSTipoPedidoEstabClassifiscService = new SLSTipoPedidoEstabClassifiscService();
    const currentTab = ref(0);
    const spanderAll = ref(false);
    const formularioAtt = ref(false);
    const formularioAdd = ref(false);
    const dataTipoPedidoEstabClassifisc = ref({
      tipopedidoid: props.value.tipopedidoid,
      estabelecimentoid: props.value.estabelecimentoid,
      classificacaofiscalid: '',
      tipopedidoestabnatopestadual: '',
      tipopedidoestabnatopinterest: '',
      tipopedidoestabnatopestrang: '',
      tipopedidoestabnatopncestadual: '',
      tipopedidoestabnatopncinterest: '',
      tipopedidoestabnatopzf: '',
      tipopedidoestabnatopimportado: '',
      tipopedidoestabnatopcfestadual: '',
      tipopedidoestabnatopcfinterest: '',
      tipopedidoestabnatoprvestadual: '',
      tipopedidoestabnatoprvinterest: '',
      tipopedidoestabnatopareaolivrecom: '',
    });
    const formularioVisible = (status, tipo, item) => {
      const { tipopedidoid, estabelecimentoid } = props.value;
      console.log(tipopedidoid, estabelecimentoid);
      if (status === 1) {
        if (tipo === 'att') {
          dataTipoPedidoEstabClassifisc.value = item;
          formularioAtt.value = true;
        } else {
          console.log(dataTipoPedidoEstabClassifisc.value);
          dataTipoPedidoEstabClassifisc.value.classificacaofiscalid = '';
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopestadual = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopinterest = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopestrang = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopncestadual = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopncinterest = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopzf = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopimportado = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopcfestadual = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopcfinterest = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatoprvestadual = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatoprvinterest = '',
          dataTipoPedidoEstabClassifisc.value.tipopedidoestabnatopareaolivrecom = '',
          formularioAdd.value = true;
        }
      } else {
        formularioAtt.value = false;
        formularioAdd.value = false;
      }
    };
    const fetchTipoPedidoEstabClassifisc = (ctx, callback) => {
      const { tipopedidoid, estabelecimentoid } = props.value;

      const queries = {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        fullObject: true,
        tipopedidoid,
        estabelecimentoid,
      };

      sLSTipoPedidoEstabClassifiscService.index(queries)
        .then((response) => {
          const { data, total } = response;
          callback(data);
          perPage.value = response.perPage;
          currentPage.value = response.page;
          totalTipoPedidoEstabClassifisc.value = total;
        })
        .catch((error) => {
          console.log(error);
          // toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: 'Error fetching users list',
          //     icon: 'AlertTriangleIcon',
          //     variant: 'danger',
          //   },
          // });
        });
    };

    const {
      perPage,
      currentPage,
      totalTipoPedidoEstabClassifisc,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refTipoPedidoEstabClassifiscListTable,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      Updated,
      create,
      removerData,
    } = useListClassifisc();

    return {
      // Filter
      avatarText,
      spanderAll,
      currentTab,
      dataTipoPedidoEstabClassifisc,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      currentPage,
      totalTipoPedidoEstabClassifisc,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchTipoPedidoEstabClassifisc,
      formularioVisible,
      tableColumns,
      formularioAdd,
      formularioAtt,
      refTipoPedidoEstabClassifiscListTable,
      Updated,
      create,
      removerData,
    };
  },
};
</script>

<template>
    <validation-observer ref="refFormData">
      <div  v-if="formularioAtt">
        <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="secondary"
        @click="formularioVisible(0)"
        >
        Voltar
        </b-button>
        <h5 class="mt-2">Todos os campos são obrigatórios.</h5>
        <b-overlay :show="isSaving" rounded="sm">
          <b-form class="mt-1" @submit.prevent >
            <b-row>
              <b-col
                  cols="6"
                  class="mb-0"
              >
                <b-form-group
                    label="Tipo Pedido"
                    label-for="tipopedidoid"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Descrição"
                      rules="required"
                  >
                    <b-form-input
                        v-model="dataForm.tipopedidoid"
                        id="tipopedidoid"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Digite o id"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Estabelecimento"
                    label-for="estabelecimentoid"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Descrição"
                      rules="required"
                  >
                    <b-form-input
                        v-model="dataForm.estabelecimentoid"
                        id="estabelecimentoid"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Digite o id"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Classificação Fiscal"
                    label-for="classificacaofiscalid"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Descrição"
                      rules="required"
                  >
                    <b-form-input
                        v-model="dataForm.classificacaofiscalid"
                        id="classificacaofiscalid"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Digite o id"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Indústria)"
                    label-for="tipopedidoestabnatopestadual"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Estadual (Indústria)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopestadual"
                        id="tipopedidoestabnatopestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Indústria)"
                    label-for="tipopedidoestabnatopinterest"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Interestadual (Indústria)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopinterest"
                        id="tipopedidoestabnatopinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Revenda)"
                    label-for="tipopedidoestabnatopestrang"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Estadual (Revenda)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopestrang"
                        id="tipopedidoestabnatopestrang"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Revenda)"
                    label-for="tipopedidoestabnatopncestadual"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Interestadual (Revenda)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopncestadual"
                        id="tipopedidoestabnatopncestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Cons.Final/Rural)"
                    label-for="tipopedidoestabnatopncinterest"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Estadual (Cons.Final/Rural)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopncinterest"
                        id="tipopedidoestabnatopncinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Cons.Final/Rural)"
                    label-for="tipopedidoestabnatopzf"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Interestadual (Cons.Final/Rural)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopzf"
                        id="tipopedidoestabnatopzf"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Não Contribuinte)"
                    label-for="tipopedidoestabnatopimportado"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Estadual (Não Contribuinte)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopimportado"
                        id="tipopedidoestabnatopimportado"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Não Contribuinte)"
                    label-for="tipopedidoestabnatopcfestadual"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Interestadual (Não Contribuinte)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopcfestadual"
                        id="tipopedidoestabnatopcfestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Estrangeira)"
                    label-for="tipopedidoestabnatopcfinterest"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper (Estrangeira)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopcfinterest"
                        id="tipopedidoestabnatopcfinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Zona Franca)"
                    label-for="tipopedidoestabnatoprvestadual"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper (Zona Franca)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatoprvestadual"
                        id="tipopedidoestabnatoprvestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Área Livre Comércio)"
                    label-for="tipopedidoestabnatoprvinterest"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper (Área Livre Comércio)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatoprvinterest"
                        id="tipopedidoestabnatoprvinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Produto Importado)"
                    label-for="tipopedidoestabnatopareaolivrecom"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper (Produto Importado)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopareaolivrecom"
                        id="tipopedidoestabnatopareaolivrecom"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            :disabled="!isFormValid"
            @click="handleUpdate(dataForm)"
          >
            Salvar Alterações
          </b-button>
        </b-overlay>
      </div>
      <b-overlay :show="isSaving" rounded="sm">
        <div  v-if="formularioAdd">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              @click="formularioVisible(0)"
          >
            Voltar
          </b-button>
          <h5 class="mt-2">Todos os campos são obrigatórios.</h5>
          <b-form class="mt-1" @submit.prevent >
            <b-row>
              <b-col
                  cols="6"
                  class="mb-0"
              >
                <b-form-group
                    label="Tipo Pedido"
                    label-for="tipopedidoid"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Descrição"
                      rules="required"
                  >
                    <b-form-input
                        v-model="dataForm.tipopedidoid"
                        id="tipopedidoid"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Digite o id"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Estabelecimento"
                    label-for="estabelecimentoid"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Descrição"
                      rules="required"
                  >
                    <b-form-input
                        v-model="dataForm.estabelecimentoid"
                        id="estabelecimentoid"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Digite o id"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Classificacao Fiscal"
                    label-for="classificacaofiscalid"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Descrição"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.classificacaofiscalid"
                        id="classificacaofiscalid"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromClassificacaoFiscal"
                        value-field="classificacao_fiscal_id"
                        text-field="classificacao_fiscal_descricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Indústria)"
                    label-for="tipopedidoestabnatopestadual"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Estadual (Indústria)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopestadual"
                        id="tipopedidoestabnatopestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Indústria)"
                    label-for="tipopedidoestabnatopinterest"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Interestadual (Indústria)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopinterest"
                        id="tipopedidoestabnatopinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Revenda)"
                    label-for="tipopedidoestabnatopestrang"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Estadual (Revenda)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopestrang"
                        id="tipopedidoestabnatopestrang"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Revenda)"
                    label-for="tipopedidoestabnatopncestadual"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Interestadual (Revenda)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopncestadual"
                        id="tipopedidoestabnatopncestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Cons.Final/Rural)"
                    label-for="tipopedidoestabnatopncinterest"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Estadual (Cons.Final/Rural)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopncinterest"
                        id="tipopedidoestabnatopncinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Cons.Final/Rural)"
                    label-for="tipopedidoestabnatopzf"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Interestadual (Cons.Final/Rural)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopzf"
                        id="tipopedidoestabnatopzf"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Não Contribuinte)"
                    label-for="tipopedidoestabnatopimportado"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Estadual (Não Contribuinte)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopimportado"
                        id="tipopedidoestabnatopimportado"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Não Contribuinte)"
                    label-for="tipopedidoestabnatopcfestadual"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper Interestadual (Não Contribuinte)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopcfestadual"
                        id="tipopedidoestabnatopcfestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Estrangeira)"
                    label-for="tipopedidoestabnatopcfinterest"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper (Estrangeira)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopcfinterest"
                        id="tipopedidoestabnatopcfinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Zona Franca)"
                    label-for="tipopedidoestabnatoprvestadual"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper (Zona Franca)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatoprvestadual"
                        id="tipopedidoestabnatoprvestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Área Livre Comércio)"
                    label-for="tipopedidoestabnatoprvinterest"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper (Área Livre Comércio)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatoprvinterest"
                        id="tipopedidoestabnatoprvinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Produto Importado)"
                    label-for="tipopedidoestabnatopareaolivrecom"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nat Oper (Produto Importado)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopareaolivrecom"
                        id="tipopedidoestabnatopareaolivrecom"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="handleSave(dataForm)"
              :disabled="!isFormValid"
          >
            Salvar Alterações
          </b-button>
        </div>
        <div v-if="!formularioAtt && !formularioAdd">
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col
                  cols="12"
                  md="6"
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>Mostrar</label>
                <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="perPageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block mx-50"
                />
                <label>entradas</label>
              </b-col>

              <b-col
                  cols="12"
                  md="6"
              >
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                      v-model="searchQuery"
                      class="d-inline-block mr-1"
                      placeholder="Pesquisar..."
                  />
                  <b-button
                      variant="primary"
                      @click="formularioVisible(1,'add')"
                  >
                    <div class="d-flex" style="gap: 5px" >
                      <iconfy icon="mdi:plus"/>
                      <span class="">Criar</span>
                    </div>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-table
              ref="refTipoPedidoEstabClassifiscListTable"
              class="position-relative"
              :items="fetchTipoPedidoEstabClassifisc"
              responsive
              :fields="tableColumns"
              primary-key="id"
              show-empty
              empty-text="Nenhum registro encontrado"
          >
            <template #table-busy>
              <div class="text-center text-secondary my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(actions)="data">
              <div>
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="gradient-primary"
                    class="btn-icon mr-1"
                    @click="formularioVisible(1, 'att',data.item)"
                >
                  <feather-icon icon="EyeIcon"/>
                </b-button>

                <b-button
                    variant="gradient-danger"
                    class="btn-icon"
                    @click="openModalDeleteClassifisc(data.item)"
                >
                  <feather-icon icon="TrashIcon"/>
                </b-button>
              </div>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{
                            dataMeta.of
                          }} entries</span>
              </b-col>

              <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >

                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalTipoPedidoEstabClassifisc"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>

        </div>
      </b-overlay>
      <modal-confirmation
          v-model="isDeleteModal"
          id-modal="modal-delete-tipo-pedido-estab-classifisc"
          title="Deletar Classifisc"
          btn-cancel-label="Cancelar"
          btn-ok-label="Sim, deletar"
          @ok="handleRemover(deletedClassifisc)"
          @cancel="resetFormData()"
      >
        <template #message>
          <div>
            <p>Tem certeza que deseja deletar essa Classificação?</p>
          </div>
        </template>
      </modal-confirmation>

    </validation-observer>

</template>
